module.exports = __webpack_public_path__ + "static/img/3.cf3e6df.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/3.png
// module id = YCT0
// module chunks = 9